<template>
  <v-row justify="center" align="center">
    <v-col cols="3">
      <p>DENNA SIDA ÄR UNDER KONSTRUKTION</p>
    </v-col>
  </v-row>
</template>

<script>
export default {};
</script>

<style></style>
